import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import TextareaAutosize from 'react-autosize-textarea';
import CompanyRegistrationDropdown from '../CompanyRegistrationDropdown';
import './PastRoleForm.scss';
var months = [{
  label: 'January',
  value: '0'
}, {
  label: 'February',
  value: '1'
}, {
  label: 'March',
  value: '2'
}, {
  label: 'April',
  value: '3'
}, {
  label: 'May',
  value: '4'
}, {
  label: 'June',
  value: '5'
}, {
  label: 'July',
  value: '6'
}, {
  label: 'August',
  value: '7'
}, {
  label: 'September',
  value: '8'
}, {
  label: 'October',
  value: '9'
}, {
  label: 'November',
  value: '10'
}, {
  label: 'December',
  value: '11'
}];
var years = function years() {
  var currentYear = new Date().getFullYear();
  var yearsArray = [{
    label: currentYear,
    value: currentYear
  }];
  var endDate = currentYear - 80;
  while (currentYear > endDate) {
    currentYear -= 1;
    yearsArray.push({
      label: currentYear,
      value: currentYear
    });
  }
  return yearsArray;
};
var renderErrorMessage = function renderErrorMessage(error) {
  var invalidEndDate = '';
  if (error.includes('The end date must be after the start date.')) {
    invalidEndDate = error.pop().toString();
    error.pop();
  }
  var length = error.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), error.length > 0 && "Please enter ".concat(error.slice(0, length - 1).join(', '), " ").concat(length > 1 ? 'and' : '', " ").concat(error.slice(-1), ". "), invalidEndDate);
};
var handleChange = function handleChange(handleInputChange, event, index) {
  var target = event.target;
  var value = target.type === 'checkbox' ? target.checked : target.value;
  handleInputChange(value, target.name, index);
};
var handleSelectChange = function handleSelectChange(handleDateChange, name, event, index) {
  handleDateChange(event, name, index);
};
function PastRoleForm(_ref) {
  var index = _ref.index,
    classNamePrefix = _ref.classNamePrefix,
    pastRole = _ref.pastRole,
    handleInputChange = _ref.handleInputChange,
    handleDateChange = _ref.handleDateChange,
    handleDeletePastRole = _ref.handleDeletePastRole,
    error = _ref.error,
    onProposalPage = _ref.onProposalPage,
    onboardingQuestionnaire = _ref.onboardingQuestionnaire;
  var dropdownStyle = {};
  return /*#__PURE__*/React.createElement("div", {
    className: "past-role-form ".concat(onboardingQuestionnaire && 'border-padding')
  }, /*#__PURE__*/React.createElement("div", {
    className: "past-roles-input-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "title"
  }, "Title"), /*#__PURE__*/React.createElement("input", {
    className: "input-base ".concat(classNamePrefix, "-title ").concat(error && error.includes('title') && 'error'),
    type: "text",
    name: "title",
    placeholder: "e.g. Senior Manager, Clinical Data Management",
    value: pastRole.title,
    onChange: function onChange(e) {
      return handleChange(handleInputChange, e, index);
    },
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "past-roles-input-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "company_name"
  }, "Company name"), /*#__PURE__*/React.createElement(CompanyRegistrationDropdown, {
    className: "input-base ".concat(classNamePrefix, "-company-name"),
    error: error && error.includes('company name') ? 'Please enter company name.' : null,
    value: pastRole.companyName,
    onChange: function onChange(data) {
      return handleInputChange(data.value, 'companyName', index);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "month-year-inputs-container"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "start_date"
  }, "Start date"), /*#__PURE__*/React.createElement("div", {
    className: "month-year-inputs"
  }, /*#__PURE__*/React.createElement(Select, {
    components: dropdownStyle,
    className: "".concat(classNamePrefix, "-start-month start-date-month"),
    classNamePrefix: "react-select",
    options: months,
    value: pastRole.startDateMonth,
    maxMenuHeight: 500,
    placeholder: "Select month",
    onChange: function onChange(e) {
      return handleSelectChange(handleDateChange, 'startDateMonth', e, index);
    }
  }), /*#__PURE__*/React.createElement(Select, {
    components: dropdownStyle,
    className: "".concat(classNamePrefix, "-start-year start-date-year"),
    classNamePrefix: "".concat(error && error.includes('start date') ? 'select-error' : 'react-select'),
    options: years(),
    value: pastRole.startDateYear,
    maxMenuHeight: 500,
    placeholder: "Select year",
    onChange: function onChange(e) {
      return handleSelectChange(handleDateChange, 'startDateYear', e, index);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "month-year-inputs-container"
  }, !pastRole.current && /*#__PURE__*/React.createElement("label", {
    htmlFor: "end_date"
  }, "End date"), /*#__PURE__*/React.createElement("div", {
    className: "month-year-inputs",
    d: true
  }, pastRole.current ? /*#__PURE__*/React.createElement("div", {
    className: ""
  }, "Present") : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Select, {
    components: dropdownStyle,
    className: "".concat(classNamePrefix, "-end-month end-date-month"),
    classNamePrefix: "react-select",
    options: months,
    value: pastRole.endDateMonth,
    maxMenuHeight: 500,
    placeholder: "Select month",
    onChange: function onChange(e) {
      return handleSelectChange(handleDateChange, 'endDateMonth', e, index);
    }
  }), /*#__PURE__*/React.createElement(Select, {
    components: dropdownStyle,
    className: "".concat(classNamePrefix, "-end-year end-date-year"),
    classNamePrefix: "".concat(error && error.includes('end date') ? 'select-error' : 'react-select'),
    options: years(),
    value: pastRole.endDateYear,
    maxMenuHeight: 500,
    placeholder: "Select year",
    onChange: function onChange(e) {
      return handleSelectChange(handleDateChange, 'endDateYear', e, index);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "input-field mb-2"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "current",
    className: "".concat(classNamePrefix, "-current"),
    checked: pastRole.current,
    onChange: function onChange(e) {
      return handleChange(handleInputChange, e, index);
    }
  }), "\xA0\xA0I currently work here"), !onProposalPage && /*#__PURE__*/React.createElement("div", {
    className: "past-roles-input-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "description"
  }, "Description"), /*#__PURE__*/React.createElement(TextareaAutosize, {
    className: "input-base ".concat(classNamePrefix, "-description ").concat(error && error.includes('description') && 'error'),
    placeholder: "Describe your role a bit more.",
    rows: 3,
    value: pastRole.description,
    name: "description",
    onChange: function onChange(e) {
      return handleChange(handleInputChange, e, index);
    },
    required: true
  })), error.length > 0 && renderErrorMessage(error), /*#__PURE__*/React.createElement("div", {
    className: "delete-past-role-container"
  }, handleDeletePastRole && /*#__PURE__*/React.createElement("div", {
    className: "delete-past-role"
  }, /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    type: "button",
    id: "delete-past-role",
    onClick: function onClick() {
      return handleDeletePastRole(index);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-trash-alt"
  })))));
}
PastRoleForm.propTypes = {
  index: PropTypes.number,
  classNamePrefix: PropTypes.string,
  pastRole: PropTypes.shape({}).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleDeletePastRole: PropTypes.func,
  error: PropTypes.arrayOf(PropTypes.string),
  onProposalPage: PropTypes.bool,
  onboardingQuestionnaire: PropTypes.bool
};
PastRoleForm.defaultProps = {
  index: null,
  classNamePrefix: '',
  error: [],
  handleDeletePastRole: null,
  onProposalPage: false,
  onboardingQuestionnaire: false
};
export default PastRoleForm;